import CampaignRoundedIcon from '@mui/icons-material/CampaignRounded';
import MarketingList from './MarketingList';

const MarketingModule = {
    list: MarketingList,
    icon: CampaignRoundedIcon,
}; export default MarketingModule;